import { Box, Center, Grid, Loader, Stack } from '@mantine/core';
import type { ReactNode } from 'react';
import { DocumentHeader } from '@/components/InvoiceDetailsModal/DocumentHeader';

/** The document page: the header across the full width, then a narrow column of navigation and details on the left and the actions above the document on the right. */
export function DocumentLayout({
  header,
  aside,
  children,
}: {
  header: ReactNode;
  aside: ReactNode;
  children: ReactNode;
}) {
  return (
    <Box>
      <Box mb="md">{header}</Box>
      <Grid gap="md">
        <Grid.Col span={{ base: 12, lg: 4, xl: 3 }}>
          <Stack gap="md">{aside}</Stack>
        </Grid.Col>
        <Grid.Col span={{ base: 12, lg: 8, xl: 9 }}>
          <Stack gap="md">{children}</Stack>
        </Grid.Col>
      </Grid>
    </Box>
  );
}

/** The page while its document loads: the same header room and columns, so nothing jumps. */
export function DocumentLoading() {
  return (
    <DocumentLayout
      header={<DocumentHeader number="" stateLabel="" stateColor="gray" />}
      aside={null}
    >
      <Center py="xl">
        <Loader />
      </Center>
    </DocumentLayout>
  );
}
